module.exports = __webpack_public_path__ + "img/8x2.2d6a2f3c.png";